module.exports = __webpack_public_path__ + "static/media/diary.7f1dfdaa.svg";